<!-- 数据需求申请 -->
<template>
  <div class="apply-page">
    <div class="apply-hero">
      <h1>{{ applyTitle }}</h1>
      <p>填写这条入驻内容，并挂到一家企业。企业可以现场填写，也可以从企业库选择。提交后进入审核，预计 1–3 个工作日。</p>
      <div v-if="businessPilotEnabled" class="business-entry">
        <el-button type="primary" @click="$router.push(+dataType === 1 ? '/demand/assistant' : '/datasets/register')">{{ +dataType === 1 ? '按用途和预算找数据' : '登记数据集并初评' }}</el-button>
      </div>
    </div>
        <el-form
          class="apply-card"
          v-loading="loading"
          :model="companyForm"
          label-width="160px"
          :rules="companyFormRules"
          ref="companyFormRef"
        >
          <div>
            <TitleTool title="数据需求信息"/>
            <div class="pr10 pl10">
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="入驻名称:"
                    label-width="160px"
                    prop="companyName"
                  >
                    <el-input
                      placeholder="请输入"
                      v-model="companyForm.companyName"
                      maxlength="100"
                      show-word-limit
                      clearable
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    :label="+dataType === 1 ? '数据需求量:' : '数量说明:'"
                    label-width="160px"
                    prop="dataRequirement"
                  >
                    <el-input
                      placeholder="请输入"
                      v-model="companyForm.dataRequirement"
                      maxlength="100"
                      show-word-limit
                      clearable
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="地点:"
                    label-width="160px"
                    prop="address"
                  >
                    <GsRegionAddress v-model="companyForm.address" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="需求行业:"
                    label-width="160px"
                    prop="businessType"
                  >
                    <GsSelect
                      v-model="companyForm.businessType"
                      class="wp100"
                      filterable
                      placeholder="行业数据选择"
                      :options="labelList"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item
                    :label="+dataType === 1 ? '数据需求描述:' : '数据服务内容:'"
                    label-width="160px"
                    prop="requireMent"
                  >
                  <el-input
                    type="textarea"
                    placeholder="请输入您数据需求内容，文字不要超过1500字"
                    v-model="companyForm.requireMent"
                    maxlength="1500"
                    show-word-limit
                    :autosize="{ minRows: 3}"
                  />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
        <EnterpriseBind ref="enterpriseBind" />
        <div class="apply-actions">
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="save">提交申请</el-button>
        </div>
  </div>
</template>
<script>
import { getDataType, regionList } from '@/api/Layout/index.js'
import { saveListing } from '@/api/Home/index.js'
import EnterpriseBind from '@/components/EnterpriseBind/index.vue'
import {enumType} from '@/utils/enum.js'
import ValidateReg from '@/utils/validateReg.js'
import { gsConfirm } from '@/utils/gsConfirm'
import GsUpload from '@/components/GsUpload/index.vue'
import GsRegionAddress from '@/components/GsRegionAddress/index.vue'
import '@/views/Layout/components/Header/components/apply-form.css'
import { businessPilotEnabled } from '@/config/business'
export default {
  name: 'DataDemandSide',
  components: { GsUpload, EnterpriseBind, GsRegionAddress },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入电话'));
      }
      
      const mobilePattern = /^1[3-9]\d{9}$/;
      const telPattern = /^(\(\d{3,4}\)|\d{3,4}-?)?\d{7,8}$/;
      
      if (mobilePattern.test(value) || telPattern.test(value)) {
        callback();
      } else {
        callback(new Error('请输入正确的手机号或座机号'));
      }
    }
    const validatePhone1 = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入联系电话'));
      }
      if(this.dataType == 2) {
        const telPattern = /^1[3-9]\d{9}$/;
        
        if (telPattern.test(value)) {
          callback();
        } else {
          callback(new Error('请输入正确的手机号'));
        }
      } else {
        const mobilePattern = /^1[3-9]\d{9}$/;
        const telPattern = /^(\(\d{3,4}\)|\d{3,4}-?)?\d{7,8}$/;
        
        if (mobilePattern.test(value) || telPattern.test(value)) {
          callback();
        } else {
          callback(new Error('请输入正确的手机号或座机号'));
        }
      }
    }
    return {
      businessPilotEnabled,
      loading: false,
      title: (this.$route.meta && this.$route.meta.title) || '',
      input2: '',
      option: [],
      labelList: [],
      DCMNSelectList: [],
      areaList: [],
      companyProductList:[],
      companyFormRules: {
        companyName: [
          { required: true, message: '请输入入驻名称', trigger: ['blur', 'change'] }
        ],
        dataRequirement: [
          { required: false, message: '请输入数据需求量', trigger: ['blur', 'change'] }
        ],
        address: [
          { required: false, message: '请输入地点', trigger: ['blur', 'change'] }
        ],
        businessType: [
          { required: false, message: '请选择数据需求行业', trigger: ['blur', 'change'] }
        ],
        requireMent: [
          { required: false, message: '请输入数据需求描述', trigger: ['blur', 'change'] }
        ]
      },
      ruleFormRules: {
        enterpriseName: [
          { required: true, message: '请输入企业全称', trigger: ['blur', 'change'] }
        ],
        enterpriseAbbreviation: [
          { required: true, message: '请输入企业简称', trigger: ['blur', 'change'] }
        ],
        companyProduct: [
          { required: false, message: '请选择公司产品', trigger: ['blur', 'change'] }
        ],
        dcmmRating: [
          { required: false, message: '请选择DCMM等级', trigger: ['blur', 'change'] }
        ],
        dateOfEstablishment: [
          { required: false, message: '请选择成立日期', trigger: ['blur', 'change'] }
        ],
        personnelSize: [
          { required: false, message: '请输入人员规模', trigger: ['blur', 'change'] }
        ],
        registeredCapital: [
          { required: false, message: '请输入注册资本', trigger: ['blur', 'change'] },
          { pattern: ValidateReg.moneyReg, message: '注册资本只能输入正数', trigger: ['blur', 'change']}
        ],
        officeAddress: [
          { required: false, message: '请输入办公地址', trigger: ['blur', 'change'] }
        ],
        typeOfEnterprise: [
          { required: false, message: '请选择企业类型', trigger: ['blur', 'change'] }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: ['blur', 'change'] },
          { 
            pattern: /^(1[3-9]\d{9}|(0\d{2,3}-)?\d{7,8}|400[0-9]{7})$/,
            message: '请输入正确的电话号码格式',
            trigger: ['blur', 'change']
          }
          // { required: true, message: '请输入电话', trigger: ['blur', 'change'] },
          // { validator: validatePhone, trigger: ['blur', 'change'] }
        ],
        url: [
          { required: false, message: '请输入企业官网地址', trigger: ['blur', 'change'] }
        ],
        email: [
          { required: false, message: '请输入邮箱', trigger: ['blur', 'change'] },
          { pattern: ValidateReg.emailReg, message: '邮箱格式不正确', trigger: ['blur', 'change']}
        ],
        administrativeDivision: [
          { required: false, message: '请选择行政区划', trigger: ['blur', 'change'] }
        ],
        companyProfile: [
          { required: false, message: '请输入公司介绍', trigger: ['blur', 'change'] }
        ],
        registrationInformation: [
          { required: false, message: '请输入数据登记', trigger: ['blur', 'change'] }
        ],
        interfaceInformation: [
          { required: false, message: '请输入数据接口', trigger: ['blur', 'change'] }
        ],
        productEvaluation: [
          { required: false, message: '请输入数据产品评价', trigger: ['blur', 'change'] }
        ],
        applicationScenario: [
          { required: false, message: '请输入应用场景', trigger: ['blur', 'change'] }
        ],
        productSpecification: [
          { required: false, message: '请输入产品规格', trigger: ['blur', 'change'] }
        ],
        limitedTerm: [
          { required: false, message: '请选择有限期限', trigger: ['blur', 'change'] }
        ],
        productServiceIndustryType: [
          { required: false, message: '请选择数据服务行业类型', trigger: ['blur', 'change'] }
        ],
        transactionAmount: [
          { required: false, message: '请输入数据评估金额（单位：万元）', trigger: ['blur', 'change'] },
          { pattern: ValidateReg.moneyReg, message: '数据评估金额（单位：万元）只能输入正数', trigger: ['blur', 'change']}
        ],
        dataAging: [
          { required: false, message: '请选择数据时效', trigger: ['blur', 'change'] }
        ],
        corporateFinancingSituationStatistics: [
          { required: false, message: '请输入数据融资金额（单位：万元）', trigger: ['blur', 'change'] },
          { pattern: ValidateReg.moneyReg, message: '数据融资金额（单位：万元）只能输入正数', trigger: ['blur', 'change'] }
        ],
        productServiceIndustryType1: [
          { required: false, message: '请选择数据服务区域', trigger: ['blur', 'change'] }
        ],
        registrationCertificate: [
          { required: false, message: '请选择是否确权', trigger: ['blur', 'change'] }
        ]
      },
      companyForm: {
        businessType: '',
        requireMent: ''
      },
      ruleForm: {
        registrationCertificate: '',
        dealerCertificate:[],
        managePicture: [],
        ownershipPicture: [],
        proprietorshipPicture: []
      },
      dialogImageUrl: '',
      dialogVisible1: false,
      typeOfEnterpriseEnum: null,
      industryEnum: null,
      dataAgingEnum: null,
      administrativeDivisionList:null
    }
  },
  computed: {
    dataType() {
      return Number(this.$route.meta && this.$route.meta.listType) || 1
    },
    applyTitle() {
      return (this.$route.meta && this.$route.meta.title) || '数据需求申请'
    }
  },
  created() {
    this.getData('sys_enterprise_type')
    this.getData('sys_data_aging')
    this.getData('sys_business_type')
    this.getData('sys_enterprise_dcmm_rating')
    this.getData('sys_yes_no')
    this.getData('sys_company_product')
    this.getData('sys_product_service_industry_type')
    this.regionArea()
  },
  methods: {
     // 地区
     regionArea() {
      regionList().then(resArea => {
        if(resArea && resArea.data && resArea.data.length > 0) {
          this.areaList = resArea.data
        } else {
          this.areaList = []
        }
      }).catch(()=>{})
    },
    // 枚举
    async getData(type) {
      try {
        const res = await getDataType(type);
        if (res && res.data && res.data.length > 0) {
          if(type === 'sys_business_type') {
            this.labelList = enumType(res.data)
          }
          if(type === 'sys_yes_no') {
            this.option = enumType(res.data)
          }
          if(type === 'sys_enterprise_dcmm_rating') {
            this.DCMNSelectList = enumType(res.data)
          }
          if(type === 'sys_enterprise_type') {
            this.typeOfEnterpriseEnum = enumType(res.data)
          }
          if(type === 'sys_data_aging') {
            this.dataAgingEnum = enumType(res.data)
          }
          if(type === 'sys_company_product') {
            this.companyProductList = enumType(res.data)
          }
          if(type === 'sys_product_service_industry_type') {
            this.industryEnum = enumType(res.data)
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error)
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible1 = true;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg'
      if (!isJPG) {
        this.$message.error('上传头像图片只能是png/jpg/jpeg格式!');
      }
      return isJPG
    },
    handleSuccess(type, response, file) {
      // 所有权
      if(type === 1 && response) {
        this.ruleForm.proprietorshipPicture.push(response.fileName)
      } else if (type === 2 && response) {
        // 持有权
        this.ruleForm.ownershipPicture.push(response.fileName)
      } else if (type === 3 && response) {
        // 经营权
        this.ruleForm.managePicture.push(response.fileName)
      } else {
        // 数据凭证
        this.ruleForm.dealerCertificate.push(response.fileName)
      }
    },
    save() {
      this.$refs.companyFormRef.validate((valid1) => {
        if (!valid1) {
          this.$message.error(this.dataType === 1 ? '请完善数据需求信息' : '请完善数据服务信息')
          this.scrollToFirstError('companyFormRef')
          return
        }
        this.$refs.enterpriseBind.validate().then((ok) => {
          if (!ok) {
            this.$message.error('请选择企业，或填写新企业')
            return
          }
          this.confirmSave()
        })
      })
    },

    confirmSave() {
      this.companyForm.listingType = +this.dataType === 2 ? '5' : '6'
      gsConfirm({
        message: '确定提交申请吗？提交后进入审核。',
        confirmButtonText: '提交',
        cancelButtonText: '再看看'
      }).then(() => {
        this.loading = true
        this.$refs.enterpriseBind.resolveId().then((enterpriseId) => {
          this.companyForm.enterpriseId = enterpriseId
          return saveListing(this.companyForm)
        }).then((resEnterprise) => {
          this.loading = false
          if (resEnterprise && resEnterprise.code === 200) {
            this.$router.go(-1)
            this.$alert('申请已提交，审核需要 1–3 个工作日，请保持电话畅通。', '提交成功', {
              confirmButtonText: '我知道了'
            })
          }
        }).catch(() => {
          this.loading = false
        })
      }).catch(() => {
        this.loading = false
      })
    },

    // 处理文件字段
    processFileFields() {
      const fileFields = [
        'dealerCertificate',
        'proprietorshipPicture', 
        'ownershipPicture',
        'managePicture'
      ]
      
      fileFields.forEach(field => {
        if(this.ruleForm[field] && this.ruleForm[field].length > 0) {
          this.ruleForm[field] = this.ruleForm[field].join(',')
        } else {
          this.ruleForm[field] = ''
        }
      })
    },

    // 处理其他字段
    processOtherFields() {
      this.ruleForm.companyProduct = JSON.stringify(this.ruleForm.companyProduct || [])
      this.ruleForm.productServiceIndustryType = JSON.stringify(this.ruleForm.productServiceIndustryType || [])
      this.ruleForm.productServiceIndustryType1 = JSON.stringify(this.ruleForm.productServiceIndustryType1 || [])
      this.companyForm.listingType = +this.dataType === 2 ? '5' : '6'
    },

    // 恢复文件字段
    restoreFileFields() {
      const fileFields = [
        'dealerCertificate',
        'proprietorshipPicture',
        'ownershipPicture', 
        'managePicture'
      ]
      
      fileFields.forEach(field => {
        this.ruleForm[field] = this.ruleForm[field] ? 
          this.ruleForm[field].split(',').map(item => item.trim()) : []
      })
    },

    // 滚动到错误字段
    scrollToFirstError(formRefName) {
      this.$nextTick(() => {
        const form = this.$refs[formRefName]
        if (form) {
          const errorElement = form.$el.querySelector('.el-form-item__error')
          if (errorElement) {
            errorElement.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'center' 
            })
          }
        }
      })
    },
    close() {
      gsConfirm({
        message: '确定离开本页吗？未提交的内容不会保存。',
        confirmButtonText: '离开',
        cancelButtonText: '继续填写'
      }).then(() => {
        this.$router.go(-1)
      }).catch(()=>{
      })
    }
  }
}
</script>
<style lang="css" scoped>
.search-content{
  padding: 20px;
}
.search-search {
  text-align: center;
}
::v-deep .form-label .el-form-item__content {
  display: flex !important;
  flex-wrap: wrap;
}
</style>
